jQuery($ => {
    class LocationsMapHero {
      constructor(element) {
        this._          = element;
        this._element   = $(element);
        this._locations = this._element.find('.o-locations-map-hero__locations');
        this._map       = this._element.find('.o-locations-map-hero__map');
        this._search    = this._element.find('.o-locations-map-hero__search');

        this._initialState = null;

        this._itemsNamespace = '.locationsMapHeroItems';

        this._storageUserKeys = LOCAL_STORAGE.user_location.keys;
        this._storageMapKeys  = LOCAL_STORAGE.map_location.keys;
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        const mapEl = this._map[0];

        if (mapEl && mapEl.google_map) {
          // plugin instance already created
          this.handleMapMarkers();
        } else {
          // wait for the map plugin to finish init
          this._map.one('google-map:init', () => {
            setTimeout(() => this.handleMapMarkers(), 0);
          });
        }

        this._map.on('google-map:ready', this.handleMapReady);
        this._map.on('google-map:marker-click', this.handleMarkerClick);
        this._map.on('google-map:marker-mouseover', this.handleMarkerMouseover);
        this._map.on('google-map:marker-mouseout', this.handleMarkerMouseout);
        this._map.on('google-map:user-interaction', this.handleMapUserInteraction);
        this._map.on('google-map:position-click', this.handlePositionClick);

        this.setupItemHandlers();

        this._search.on('search:position-found', (_, position) => this.handlePositionFound(position));
        this._search.on('search:suggestion-picked', (_, text) => this.handleSuggestionPick(text));
        this._search.on('search:clear-geo', () => this.handleSearchGeoClear());
        this._search.on('search:action', () => this.handleHomeClick());

        let resizeTimeout;
        $(window).on('resize', () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(() => this.handleWindowSize(), 150);
        });

        $(window).on('load', () => {
          this.handleWindowSize();
        });

        $(window).on('popstate', this.handleBackButton);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Check Local Storage
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      checkLocalStorage = (field = 'map') => {
        let keys = false;

        switch (field) {
          case 'map':
            keys = this._storageMapKeys;
            break;
          case 'user':
            keys = this._storageUserKeys;
            break;
        }
        
        if (!keys) return;

        const lat = localStorage.getItem(keys.lat);
        const lng = localStorage.getItem(keys.lng);

        if (!lat || !lng) return null;

        const storage = {
          lat: parseFloat(lat),
          lng: parseFloat(lng)
        };

        if (field == 'user') {
          storage.type = localStorage.getItem(keys.type);
        }

        return storage;
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Update Local Storage
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      updateLocalStorage = (location, field = 'map') => {
        if (!location) return;

        switch (field) {
          case 'map':
            keys = this._storageMapKeys;
            break;
          case 'user':
            keys = this._storageUserKeys;
            break;
        }
        
        if (!keys) return;

        Object.entries(keys).forEach(([key, storageKey]) => {
          const value = location[key];
          
          if (value === undefined || value === null) return;
          
          if (typeof value === 'object' && !Array.isArray(value)) {
            Object.entries(value).forEach(([subKey, subValue]) => {
              if (subValue !== undefined && subValue !== null) {
                localStorage.setItem(`${storageKey}.${subKey}`, subValue);
              }
            });
          } else {
            localStorage.setItem(storageKey, value);
          }
        });
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Get Map Padding
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      getMapPadding = () => {
        const width = window.innerWidth;

        if (width <= 950) {
          return {
            top: 84,
            bottom: 94
          }
        } else {
          return {
            top: this._search,
            left: this._locations
          }
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Map Markers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleMapMarkers = (markers = [], options = {}) => {
        const mapEl = this._map[0];
        if (!mapEl || !mapEl.google_map) return;

        if (!markers.length) {
          const $items = this._locations.find('.m-location-item');

          $items.each((index, item) => {
            const $item = $(item);
            const lat   = parseFloat($item.data('lat'));
            const lng   = parseFloat($item.data('lng'));
            const markerType = $item.data('marker');
            
            if (lat != null && lng != null) {
              markers.push({
                position: { lat, lng },
                state: 'idle',
                icon: GOOGLE_MAPS.markers[markerType].idle,
                iconStates: {
                  idle: GOOGLE_MAPS.markers[markerType].idle,
                  hover: GOOGLE_MAPS.markers[markerType].hover,
                  active: GOOGLE_MAPS.markers[markerType].active
                },
                index,
                item
                // you can also pass per-marker options here, e.g.:
                // icon: GOOGLE_MAPS.markers.special,
                // title: $item.find('.m-location-item__title').text().trim()
              });
            }
          });
        }

        if (!markers.length) return;

        const { position } = options;

        mapEl.google_map.setMarkers(markers, { 
          fitBounds: true,
          fitBoundsOptions: {
            position,
            padding: this.getMapPadding()
          }
        });

        if (!this._initialState) {
          this._initialState = {
            locations: this._locations.clone(true, true),
            markers: [...markers],
            searchVal: this._search.search('getValue')
          };
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Window Size
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleWindowSize = () => {
        const width = window.innerWidth;

        this._map.google_map('updatePadding', this.getMapPadding());

        if (width <= 600) {
          this._map.google_map('updateArgs', {
            fullscreenControl: false,
            cameraControl: false
          });
        } else if (width <= 950) {
          this._map.google_map('updateArgs', {
            fullscreenControlOptions: {
              position: 3
            },
            fullscreenControl: true,
            cameraControl: true
          });
        } else {
          this._map.google_map('updateArgs', {
            fullscreenControlOptions: {
              position: 9
            },
            fullscreenControl: true,
            cameraControl: true
          });
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Marker Click
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleMarkerClick = (event, marker) => {
        if (marker.iconStates?.active) {
          marker.setIcon(marker.iconStates.active);
        }

        const $items  = this._locations.find('.m-location-item');
        const $target = $items.eq(marker.index);

        this.deactivateAllMarkers();
        this.activateMarker(marker);

        if (!$target.length) return;

        this.activateItem($target);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Marker Mouseover
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleMarkerMouseover = (event, marker) => {
        this.focusMarker(marker);

        const $item = $(marker.item);
        
        if ($item.length) {
          this.focusItem($item);
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Marker Mouseout
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleMarkerMouseout = (event, marker) => {
        if (marker.state === 'active') return;

        this.deactivateMarker(marker);

        const $item = $(marker.item);
        
        if ($item.length) {
          this.unfocusItem($item);
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Position Click
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handlePositionClick = () => {
        this.handleMapUserInteraction();
        this.deactivateAllMarkers();
        this.deactivateAllItems();
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Map User Interaction
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleMapUserInteraction = () => {
        this._search.search('showAction');
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Map Ready
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleMapReady = () => {
        const searchVal = this._search.search('getValue');

        if (searchVal == 'Current Location') {
          const localStorage = this.checkLocalStorage('user');

          if (!localStorage) return;

          const { type, lat, lng } = localStorage;

          this._userPosition = { lat, lng };

          if (type == 'precise') {
            this.handlePosition();
          }
        } else if (searchVal.length) {
          this.handleAddressSearch();
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Focus Marker
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      focusMarker = (marker) => {
        if (!marker) return;

        if (marker.state === 'active') return;

        marker.setZIndex(9999);

        if (marker.iconStates?.hover) {
          marker.setIcon(marker.iconStates.hover);
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Unfocuse Marker
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      unfocusMarker = (marker) => {
        if (!marker) return;

        if (marker.state === 'active') return;
        
        marker.setZIndex(0);

        this.deactivateMarker(marker);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Activate Marker
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      activateMarker = (marker) => {
        if (!marker) return;
        
        marker.state  = 'active';
        marker.cursor = 'default';
        marker.setZIndex(10);

        if (marker.iconStates?.active) {
          marker.setIcon(marker.iconStates.active);
        }

        // Fit marker in view with custom padding to account for sidebar and search bar
        this._map.google_map('fitMarkerInView', marker, {
          zoom: 12,
          padding: this.getMapPadding()
        });

        // Deactivate all other markers
        this.deactivateMarker(this._map.google_map('getMarkers').find(m => m !== marker));
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Deactivate Marker
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      deactivateMarker = (marker) => {
        if (!marker) return;

        marker.state  = 'idle';
        marker.cursor = 'pointer';
        marker.setZIndex(0);

        if (marker.iconStates?.idle) {
          marker.setIcon(marker.iconStates.idle);
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Deactivate All Markers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      deactivateAllMarkers = () => {
        const markers = this._map.google_map('getMarkers');
        markers.forEach(marker => this.deactivateMarker(marker));
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Item Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      setupItemHandlers = () => {
        // Bind once per instance, namespace per instance to avoid duplicates
        this._element.off(this._itemsNamespace);

        this._element.on(`click${this._itemsNamespace}`, '.m-location-item', (event) => {
          if ($(event.target).is('a') || $(event.target).closest('a').length) return;

          const $item = $(event.currentTarget);

          // IMPORTANT: index relative to CURRENT locations container
          const index = this._locations
            .find('.m-location-item')
            .index($item);

          this.handleItemClick($item, index);
        });

        this._element.on(`mouseover${this._itemsNamespace}`, '.m-location-item', (event) => {
          const $item = $(event.currentTarget);
          const index = this._locations
            .find('.m-location-item')
            .index($item);

          this.handleItemMouseover($item, index);
        });

        this._element.on(`mouseout${this._itemsNamespace}`, '.m-location-item', (event) => {
          const $item = $(event.currentTarget);
          const index = this._locations
            .find('.m-location-item')
            .index($item);

          this.handleItemMouseout($item, index);
        });
      }


      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Item Click
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleItemClick = ($item, index) => {
        this.activateItem($item);
        const markers = this._map.google_map('getMarkers');

        this.deactivateAllMarkers();
        this.activateMarker(markers[index])
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Item Mouseover
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleItemMouseover = ($item, index) => {
        const markers = this._map.google_map('getMarkers');

        this.focusMarker(markers[index]);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Item Mouseout
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleItemMouseout = ($item, index) => {
        const markers = this._map.google_map('getMarkers');

        this.unfocusMarker(markers[index]);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Scroll To Item
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      scrollToItem = ($item) => {
        const scrollerHeight = this._locations.innerHeight();
        const itemOffset     = $item.position().top;
        const itemHeight     = $item.outerHeight();

        const scrollTo = itemOffset + this._locations.scrollTop() - (scrollerHeight / 2) + (itemHeight / 2);

        this._locations.animate({ scrollTop: scrollTo }, 300);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Activate Item
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      activateItem = ($item) => {
        this._search.search('showAction');
        this.deactivateAllItems();
        $item.addClass('m-location-item--active');
        this.scrollToItem($item);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Deactivate Item
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      deactivateItem = ($item) => {
        $item.removeClass('m-location-item--active');
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Focus Item
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      focusItem = ($item) => {
        $item.addClass('m-location-item--focus');
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Unfocus Item
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      unfocusItem = ($item) => {
        $item.removeClass('m-location-item--focus');
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Deactivate All Items
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      deactivateAllItems = () => {
        this.deactivateItem(this._locations.find('.m-location-item'));
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Position
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handlePosition = (position = null) => {
        if (position) {
          this._userPosition = position;
        }

        this._map.google_map('addPositionMarker', this._userPosition);
        this.handleLocationsNearUserRequest();
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Position Found
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handlePositionFound = (position = null) => {
        this._search.search('handleSearchHistory', 'Current Location');
        this.handlePosition(position);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Suggestion Pick
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleSuggestionPick = (text) => {
        this._search.search('handleSearchHistory', text);
        this.handleAddressSearch(text);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Search Geolocation Clear
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleSearchGeoClear = () => {
        this._search.search('handleSearchHistory', '');
        this._map.google_map('resetPosition');
        this.deactivateAllItems();
        this.deactivateAllMarkers();
        this._search.search('hideAction');
        this._locations.animate({ scrollTop: 0 }, 300);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Reset
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleReset = () => {
        if (this._initialState) {
          this._locations.replaceWith(this._initialState.locations.clone(true, true));
          this._locations = this._element.find('.o-locations-map-hero__locations');
          this.handleMapMarkers(this._initialState.markers.map(m => ({...m})));
        }

        this._map.google_map('removePositionMarker');
        this._search.search('handleClear');
        this.handleSearchGeoClear();
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Home Click
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleHomeClick = () => {
        this.handleReset();
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Locations Near User Request
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleLocationsNearUserRequest = (event) => {
        let data = {
          action: 'locations_near_user',
          data: {
            user_location: this._userPosition,
            class: 'o-locations-map-hero__locations',
            callback: 'get_location_scroll',
            radius: 50
          }
        }

        $.ajax({
          url: AJAX.url,
          type: 'POST',
          data,
          success: this.handleNearUserRequestResponse
        });
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Near User Request Response
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleNearUserRequestResponse = (response) => {
        const isSuccess = response.success === undefined || response.success;
        const data      = response.data || {};
        const location  = data.location || {};

        if (location) {
          this._userLocation = location;
        }

        if (isSuccess) {
          this.handleRequestSuccess(data, this._userPosition);
        } else {
          this.handleRequestError(data);
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Address Search
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleAddressSearch = (address = null) => {
        this._addressSearch = address || this._search.search('getValue');

        if (!this._addressSearch.length) return;
        
        this.handleLocationsNearAddressRequest();
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Locations Near Address Request
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleLocationsNearAddressRequest = (event) => {
        let data = {
          action: 'locations_near_address',
          data: {
            address: this._addressSearch,
            class: 'o-locations-map-hero__locations',
            callback: 'get_location_scroll',
            radius: 50
          }
        }

        $.ajax({
          url: AJAX.url,
          type: 'POST',
          data,
          success: this.handleNearAddressRequestResponse
        });
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Near Address Request Response
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleNearAddressRequestResponse = (response) => {
        const isSuccess = response.success === undefined || response.success;
        const data      = response.data || {};
        const location  = data.location || {};
        let   position  = null;

        if (location) {
          this._mapLocation = location;
          this.updateLocalStorage(location, 'map');
          position = { lat: location.lat, lng: location.lng };
        }

        if (isSuccess) {
          this._map.google_map('addPositionMarker', position);
          this.handleRequestSuccess(data, position);
        } else {
          this.handleRequestError(data);
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Request Success
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleRequestSuccess = (data, position = null) => {
        if ( !data.success ) {
          this.handleEmptyResponse(data);
          return;
        }

        const $newLocations = $(data.data);

        if (!$newLocations.length || !$newLocations.find('.m-location-item').length) return;

        this._locations.replaceWith($newLocations);
        this._locations = $newLocations;

        this.handleMapMarkers([], { position });
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Request Error
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleRequestError = (data) => {
        console.error('Status: Filter ajax request failed', data);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Empty Response
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleEmptyResponse = (data) => {
        const $list = this._locations.find('.m-location-items__list');

        if ($list.length) {
          $list.replaceWith(data.data);
          this._search.search('showAction');
          this._map.google_map('setMarkers', []);
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Back Button
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleBackButton = (event) => {
        const state = event.originalEvent?.state;
        
        if (state !== null && state !== undefined) {
          if (state?.search) {
            if (state.search !== this._search.find('input').val()) {
              this.handleAddressSearch(state.search);
            }
          } else {
            this.handleReset();
          }
        }
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.locations_map_hero = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].locations_map_hero = new LocationsMapHero(_[i], opt);
        else
          ret = _[i].locations_map_hero[opt].apply(_[i].locations_map_hero, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.o-locations-map-hero').locations_map_hero();
});